import React from 'react';

import { IconType } from 'react-icons/lib';

import { Container, ContainerWhite } from './styles';

import Vimeo from '../../components/Vimeo';
import VideoGallery from '../../components/VideoGallery';
import ImageGallery from '../../components/ImageGallery';
import Speakers from '../Speakers';
import Slider from 'react-slick';
import SliderContainer from '../../components/Slider';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const SlidesImagens: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  return (
    <>

     <Container >
     <h1 style={{width:'100%', margin: '40px 10px', marginBottom:'10px', fontSize:'24px', textAlign:'center'}}>Apresentação</h1>
 
      <SliderContainer>
  <div><img src="/slide/Slide1.JPG" style={{width: '100%'}}/></div>
  <div><img src="/slide/Slide2.JPG" style={{width: '100%'}}/></div>
  <div> <img src="/slide/Slide3.JPG" style={{width: '100%'}}/></div>
  <div><img src="/slide/Slide4.JPG" style={{width: '100%'}}/></div>
  <div><img src="/slide/Slide5.JPG" style={{width: '100%'}}/></div>
  
  </SliderContainer>
      </Container>
    </>
  );
};
export default SlidesImagens;
